module.exports = __webpack_public_path__ + "media/bootstrap-icons/plus-lg-c5684a82.svg";